var map = {
	"./background-desktop.webp": 9831,
	"./background-quick-start.webp": 1193,
	"./background-testimonials-desktop.webp": 5008,
	"./banner-about-desktop.webp": 6961,
	"./banner-about-mobile.webp": 8813,
	"./banner-auditory-desktop.webp": 1867,
	"./banner-auditory-mobile.webp": 8719,
	"./banner-home-desktop.webp": 5513,
	"./banner-home-mobile.webp": 6021,
	"./banner-queries-desktop.webp": 6736,
	"./banner-queries-mobile.webp": 8734,
	"./banner-testimonials-desktop.webp": 1258,
	"./banner-testimonials-mobile.webp": 8976,
	"./products/statistics-benefits-product.webp": 7285,
	"./products/statistics-budgets-product.webp": 4673,
	"./products/statistics-finances-product.webp": 7750,
	"./products/statistics-metrics-product.webp": 7894,
	"./quick-start-desktop.webp": 6473,
	"./succes-stories/alvarado.webp": 7981,
	"./succes-stories/calcagno.webp": 1039,
	"./succes-stories/details/alvarado_1.webp": 6506,
	"./succes-stories/details/alvarado_2.webp": 6027,
	"./succes-stories/details/alvarado_3.webp": 3208,
	"./succes-stories/details/alvarado_hero.webp": 2487,
	"./succes-stories/details/calcagno-hero.webp": 187,
	"./succes-stories/details/calcagno_1.webp": 6716,
	"./succes-stories/details/calcagno_2.webp": 3577,
	"./succes-stories/details/calcagno_3.webp": 9070,
	"./succes-stories/details/calcagno_mobile-1.webp": 9937,
	"./succes-stories/details/calcagno_mobile-2.webp": 2596,
	"./succes-stories/details/corti_2.webp": 9220,
	"./succes-stories/details/corti_3.webp": 3879,
	"./succes-stories/details/dentist_tablet.webp": 6754,
	"./succes-stories/details/marion_1.webp": 3396,
	"./succes-stories/details/marion_2.webp": 881,
	"./succes-stories/details/marion_3.webp": 5558,
	"./succes-stories/details/marion_hero.webp": 9541,
	"./succes-stories/details/marion_mobile-1.webp": 6729,
	"./succes-stories/details/marion_mobile-2.webp": 7340,
	"./succes-stories/details/orono_1.webp": 4511,
	"./succes-stories/details/orono_2.webp": 2062,
	"./succes-stories/details/orono_3.webp": 1785,
	"./succes-stories/details/orono_hero.webp": 3132,
	"./succes-stories/details/orono_mobile-1.webp": 2880,
	"./succes-stories/details/orono_mobile-2.webp": 9613,
	"./succes-stories/details/tantera_1.webp": 2035,
	"./succes-stories/details/tantera_3.webp": 9101,
	"./succes-stories/marion.webp": 2556,
	"./succes-stories/orono.webp": 5290,
	"./succes-stories/stacks/alvarado.webp": 2409,
	"./succes-stories/stacks/calcagno.webp": 8427,
	"./succes-stories/stacks/marion.webp": 7971,
	"./succes-stories/stacks/orono.webp": 8830
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6398;